import script from "./TheReserveDay.vue?vue&type=script&setup=true&lang=ts"
export * from "./TheReserveDay.vue?vue&type=script&setup=true&lang=ts"

import "./TheReserveDay.vue?vue&type=style&index=0&id=4bec00c4&lang=scss&scoped=true"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bec00c4"]])

export default __exports__